// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import MDButton from "theme/components/MDButton";
import MDInput from "theme/components/MDInput";
import usePageTitle from "app/pageTitle";

// import { useMaterialUIController } from "context";

function CreateBeneficiary() {
  const pageTitle = "New Beneficiary";
  usePageTitle(pageTitle);

  const navigate = useNavigate();
  // const [controller] = useMaterialUIController();
  // const { darkMode } = controller;

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [currencies, setCurrencies] = useState([]);
  const [currency, setCurrency] = useState("NGN");
  const [countries, setCountries] = useState([]);
  // const [country, setCountry] = useState(null);
  const [relationshipTypes, setRelationshipTypes] = useState([]);
  const [beneficiaryType, setBeneficiaryType] = useState("individual");
  const [paymentInfo, setPaymentInfo] = useState({});
  const [currencyPaymentInfo, setCurrencyPaymentInfo] = useState([]);
  const [userPaymentInfo, setUserPaymentInfo] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("users/beneficiaries/create/init.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setCurrencies(result.data.data.result.currencies);
            setCountries(result.data.data.result.countries);
            setRelationshipTypes(result.data.data.result.relationship_types);
            setPaymentInfo(result.data.data.result.payment_info);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred. Please try again in a few moments.");
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  const handleuserPaymentInfoChange = (event) => {
    const arr = userPaymentInfo;
    arr[event.target.name] = event.target.value;
    setUserPaymentInfo(arr);
  };

  const [state, setState] = useState({});
  const {
    country = null,
    relationshipType = null,
    lastName = null,
    firstName = null,
    companyName = null,
    alias = null,
    address = null,
    city = null,
    addressState = null,
    postalCode = null,
  } = state;

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const postData = async (params) => {
    setShowLoading(true);
    await axios
      .post("users/beneficiaries/create.json", params)
      .then((response) => {
        setShowLoading(false);
        if (response.data.status === "success") {
          setSeverity("success");
          setErrMsg("Beneficiary saved successfully.");
          setOpen(true);
          navigate("/beneficiaries");
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg("An error occurred. Please try again in a few moments.");
        setOpen(true);
        setShowLoading(false);
      });
  };

  const handleSubmit = () => {
    if (currency === null) {
      setSeverity("error");
      setErrMsg("A currency is required");
      setOpen(true);
      return;
    }
    if (country === null) {
      setSeverity("error");
      setErrMsg("A country is required");
      setOpen(true);
      return;
    }

    if (beneficiaryType === null) {
      setSeverity("error");
      setErrMsg("Select a beneficiary type.");
      setOpen(true);
      return;
    }

    if (relationshipType === null) {
      setSeverity("error");
      setErrMsg("Set a relationship type.");
      setOpen(true);
    }

    if (beneficiaryType === "individual") {
      if (lastName === null) {
        setSeverity("error");
        setErrMsg("Enter a last name");
        setOpen(true);
        return;
      }
      if (firstName === null) {
        setSeverity("error");
        setErrMsg("Enter a first name");
        setOpen(true);
        return;
      }
    } else {
      if (companyName === null) {
        setSeverity("error");
        setErrMsg("Enter a company name");
        setOpen(true);
        return;
      }
      setSeverity("error");
    }

    if (alias === null) {
      setSeverity("error");
      setErrMsg("Enter an alias/nickname for this beneficiary.");
      setOpen(true);
    }

    if (address === null) {
      setSeverity("error");
      setErrMsg("Address is required.");
      setOpen(true);
      return;
    }
    if (addressState === null) {
      setSeverity("error");
      setErrMsg("State is required");
      setOpen(true);
      return;
    }
    if (city === null) {
      setSeverity("error");
      setErrMsg("City is required");
      setOpen(true);
      return;
    }
    if (postalCode === null) {
      setSeverity("error");
      setErrMsg("Postal code required");
      setOpen(true);
      return;
    }

    if (userPaymentInfo === null || userPaymentInfo.length <= 0) {
      setSeverity("error");
      setErrMsg("Please enter required payment information.");
      setOpen(true);
      return;
    }

    const params = {
      currency: `${currency}`,
      first_name: firstName,
      last_name: lastName,
      company_name: companyName,
      alias: `${alias}`,
      beneficiary_type: beneficiaryType,
      relationship_type: relationshipType,
      address: `${address}`,
      city: `${city}`,
      state: addressState,
      postal_code: postalCode,
      country: `${country}`,
      banking_details: userPaymentInfo,
    };
    // console.log(params);
    postData(params);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {/* <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox sx={{ marginBottom: "40px" }}>
                  <MDBox display="flex" alignItems="center" justifyContent="space-between">
                    <MDBox>
                      <MDButton
                        variant="link"
                        color={darkMode ? "white" : "dark"}
                        onClick={() => {
                          navigate("/beneficiaries");
                        }}
                      >
                        My Beneficiaries
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Grid>
            </Grid> */}
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={6}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                        Beneficiary Information
                      </MDTypography>
                      <MDBox mt={5}>
                        <MDBox mb={5}>
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={6} lg={6}>
                              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                <InputLabel>Currency</InputLabel>
                                <Select
                                  label="Currency"
                                  onChange={(e) => {
                                    setUserPaymentInfo({});
                                    setCurrency(e.target.value);
                                    setCurrencyPaymentInfo(
                                      paymentInfo[e.target.value][beneficiaryType]
                                    );
                                    handleChange(e);
                                  }}
                                  sx={{ padding: "12px", paddingLeft: "3px" }}
                                >
                                  {
                                    // --> Notice below changes
                                    currencies.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                      currencies.map((record) => {
                                        if (record.payout_enabled) {
                                          return (
                                            <MenuItem value={record.currency_code}>
                                              {record.currency_code}
                                            </MenuItem>
                                          );
                                        }
                                        return null;
                                      })
                                  }
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                <InputLabel>Country</InputLabel>
                                <Select
                                  name="country"
                                  onChange={handleChange}
                                  label="Country"
                                  // onChange={(e) => handleCurrencyChange(e.target.value)}
                                  sx={{ padding: "12px", paddingLeft: "3px" }}
                                >
                                  {
                                    // --> Notice below changes
                                    countries.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                      countries.map((record) => (
                                        <MenuItem value={record.code}>{record.title}</MenuItem>
                                      ))
                                  }
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                <InputLabel>Relationship Type</InputLabel>
                                <Select
                                  name="relationshipType"
                                  label="Relationship Type"
                                  onChange={handleChange}
                                  // onChange={(e) => handleCurrencyChange(e.target.value)}
                                  sx={{ padding: "12px", paddingLeft: "3px" }}
                                >
                                  {
                                    // --> Notice below changes
                                    relationshipTypes.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                      relationshipTypes.map((record) => (
                                        <MenuItem value={record.code}>{record.title}</MenuItem>
                                      ))
                                  }
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                <InputLabel>Beneficiary Type</InputLabel>
                                <Select
                                  label="Beneficiary Type"
                                  name="beneficiary_type"
                                  sx={{ padding: "12px", paddingLeft: "3px" }}
                                  onChange={(e) => {
                                    setUserPaymentInfo({});
                                    setBeneficiaryType(e.target.value);
                                    if (currency != null) {
                                      setCurrencyPaymentInfo(paymentInfo[currency][e.target.value]);
                                      handleChange(e);
                                    }
                                  }}
                                >
                                  <MenuItem value="individual">Individual</MenuItem>
                                  <MenuItem value="company">Company</MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                          </Grid>
                          {beneficiaryType === "individual" ? (
                            <MDBox mt={3}>
                              <Grid container spacing={3}>
                                <Grid item xs={12} md={6} lg={6}>
                                  <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                    <MDInput
                                      onChange={handleChange}
                                      name="lastName"
                                      label="Last Name"
                                      sx={{ minWidth: 120, width: "100%" }}
                                    />
                                  </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                  <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                    <MDInput
                                      onChange={handleChange}
                                      name="firstName"
                                      label="First Name"
                                      sx={{ minWidth: 120, width: "100%" }}
                                    />
                                  </FormControl>
                                </Grid>
                              </Grid>
                            </MDBox>
                          ) : (
                            <MDBox mt={3}>
                              <Grid container>
                                <Grid item xs={12} md={12} lg={12}>
                                  <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                    <MDInput
                                      onChange={handleChange}
                                      name="companyName"
                                      label="Company Name"
                                      sx={{ minWidth: 120, width: "100%" }}
                                    />
                                  </FormControl>
                                </Grid>
                              </Grid>
                            </MDBox>
                          )}
                          <MDBox mt={3}>
                            <Grid container>
                              <Grid item xs={12} md={12} lg={12}>
                                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                  <MDInput
                                    multilines
                                    lines={3}
                                    name="alias"
                                    label="Beneficiary Nickname/Alias"
                                    sx={{ minWidth: 120, width: "100%" }}
                                    onChange={handleChange}
                                  />
                                </FormControl>
                              </Grid>
                            </Grid>
                          </MDBox>
                          <MDBox mt={3}>
                            <Grid container>
                              <Grid item xs={12} md={12} lg={12}>
                                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                  <MDInput
                                    multilines
                                    lines={3}
                                    name="address"
                                    label="Address"
                                    sx={{ minWidth: 120, width: "100%" }}
                                    onChange={handleChange}
                                  />
                                </FormControl>
                              </Grid>
                            </Grid>
                          </MDBox>
                          <MDBox mt={3}>
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={4} lg={4}>
                                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                  <MDInput
                                    name="city"
                                    label="City"
                                    sx={{ minWidth: 120, width: "100%" }}
                                    onChange={handleChange}
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item xs={12} md={4} lg={4}>
                                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                  <MDInput
                                    name="addressState"
                                    label="State"
                                    sx={{ minWidth: 120, width: "100%" }}
                                    onChange={handleChange}
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item xs={12} md={4} lg={4}>
                                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                  <MDInput
                                    name="postalCode"
                                    label="Postal Code"
                                    sx={{ minWidth: 120 }}
                                    onChange={handleChange}
                                  />
                                </FormControl>
                              </Grid>
                            </Grid>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                        Payment Information
                      </MDTypography>
                      <MDBox mt={5}>
                        <MDBox mb={5}>
                          <Grid container spacing={3}>
                            {currencyPaymentInfo.map((info) => {
                              if (info.options != null) {
                                return (
                                  <Grid item xs={12} md={6} lg={6}>
                                    <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                      <InputLabel>{info.display_name}</InputLabel>
                                      <Select
                                        name={info.param}
                                        label={info.display_name}
                                        onChange={(e) => handleuserPaymentInfoChange(e)}
                                        sx={{ padding: "12px", paddingLeft: "3px" }}
                                      >
                                        {
                                          // --> Notice below changes
                                          info.options.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                            info.options.map((opt) => (
                                              <MenuItem value={opt.value}>{opt.name}</MenuItem>
                                            ))
                                        }
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                );
                              }
                              return (
                                <Grid item xs={12} md={6} lg={6}>
                                  <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                    <MDInput
                                      onChange={handleuserPaymentInfoChange}
                                      // value={userPaymentInfo[info.param] || ""}
                                      errorMessages={[`${info.display_name} is required`]}
                                      validators={["required"]}
                                      name={info.param}
                                      label={info.display_name}
                                    />
                                  </FormControl>
                                </Grid>
                              );
                            })}
                          </Grid>
                        </MDBox>
                        {/* <MDBox mt={5}>
                          <MDButton variant="contained" color="dark" onClick={handleSubmit}>
                            Save Beneficiary
                          </MDButton>
                        </MDBox> */}
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
                <MDBox mt={5}>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDButton variant="contained" color="dark" onClick={handleSubmit}>
                        Save Beneficiary
                      </MDButton>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CreateBeneficiary;
